import { GLServiceBase, ServiceRoute, GLUtil } from "commonui";
import {
	ComponentObjectiveReportDataModel,
	ComponentObjectiveReportQueryParamsModel,
	IObjectiveService,
	MasteryObjectiveReportDataModel,
	MasteryQuestionReportExportParamsModel,
	MasteryQuestionReportQueryParamsModel,
	UnitobjectiverelatedwithparentModel
} from ".";

class ObjectiveServiceClass extends GLServiceBase<any, any> implements IObjectiveService {
	constructor() {
		super();
		this.getMasteryObjectiveReport = this.getMasteryObjectiveReport.bind(this);
	}

	serviceRoute: ServiceRoute = { prefix: "content/v1/objectives" };

	getObjectives(params: any): Promise<any[]> {
		return this.request.get(this.url(""), params);
	}
	getObjectivesTree(params: any): Promise<any> {
		return this.get("tree", params);
	}
	updateObjective(model): Promise<any> {
		return this.update(model);
	}
	createObjective(model): Promise<any> {
		return this.create(model);
	}
	deleteObjective(objectiveId: string): Promise<any> {
		return this.delete("{objectiveId}", { objectiveId });
	}
	createContentObjectives(params: any): Promise<any> {
		return this.create("contentobjectives", params);
	}
	getUnitObjectives(params: any): Promise<any> {
		return this.get("unitobjectives", params);
	}
	getUnitobjectiverelated(params: any): Promise<any> {
		return this.get("{objectiveId}/unitobjectiverelated", params);
	}
	getRelatedContents(params: any): Promise<any> {
		return this.get("{objectiveId}/relatedcontents", params);
	}
	exportPDF(params: any): Promise<any> {
		return this.getBlob("unitobjectives/pdf", params);
	}
	exportExcel(params: any): Promise<any> {
		return this.getBlob("unitobjectives/excel", params);
	}
	exportObjectiveReport(params: any): Promise<any> {
		return this.download({
			suffix: "objectivereport",
			data: params,
			method: "post",
			removeQueryParam: true
		});
	}
	swapingTreeNodes(params: any): Promise<any> {
		return this.update("{preObjectiveId}/swaping/{nextObjectiveId}/{swappedObjectiveId}", params);
	}
	getUnitObjectiveRelatedWithParent(params: any): Promise<UnitobjectiverelatedwithparentModel> {
		return this.get("unitobjectiverelatedwithparent", params);
	}

	getReportData(
		startUnitId: number | undefined,
		endUnitId: number | undefined,
		versionGroupId: string,
		curriculumType: number,
		queryParams: ComponentObjectiveReportQueryParamsModel
	): Promise<ComponentObjectiveReportDataModel[]> {
		return this.get(
			`componentobjectives/${startUnitId}/${endUnitId}/${versionGroupId}/${curriculumType}`,
			queryParams
		);
	}

	getMasteryObjectiveReport(
		queryParams: MasteryQuestionReportQueryParamsModel
	): Promise<MasteryObjectiveReportDataModel> {
		return this.get(`masteryobjectives`, queryParams);
	}

	exportMasteryObjectiveReport(queryParams: MasteryQuestionReportExportParamsModel): Promise<any> {
		return this.download({
			suffix: "exportmasteryobjectivereport",
			data: queryParams,
			method: "get",
		});
	}
}

export const ObjectiveService = new ObjectiveServiceClass();
